import React from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { get } from 'lodash';
import correctIcon from 'assets/images/correct.png';
import './style.scss';

const ESignContarctModificationCompelete = () => {
  const { loanId } = useParams();
  const location = useLocation();
  const externalId = get(location, 'state.externalId') || loanId;

  return (
    <div className="thankyou-wrapper">
      {externalId ? (
        <div>
          <p className="mb-0 p-large">
            <b>Loan ID:</b>
            {' '}
            {externalId}
          </p>
        </div>
      ) : null}
      <div className="thankyou-inner-wrapper text-center">
        <img src={correctIcon} alt="Complete" />
        <h2>Thank You!</h2>
        <p>That&apos;s all we need for now.</p>
      </div>
    </div>
  );
};

ESignContarctModificationCompelete.propTypes = {};

ESignContarctModificationCompelete.defaultProps = {};

export default ESignContarctModificationCompelete;
